enum ApiRoutes {
  CLIENTS = '/clients',
}

export default ApiRoutes;
